const unitTemplates = {}

import unitJobs from "@frog/source/data/unit-jobs.js"
Object.keys(unitJobs).forEach((unitJobKey) => {
    const unit = unitJobs[unitJobKey]
    unitTemplates["jobs/" + unitJobKey] = {
        "templateKey": "jobs/" + unitJobKey,
        "jobKey": unitJobKey,
        "affiliation": "bad",
    }
})

export const UNIT_JOB_LISTS = {
    "infantry": ["sword", "spear", "hammer"],
    "ranged": ["dagger", "bow", "gun"],
    "mounted": ["swordcavalier", "spearcavalier", "hammercavalier"],
    "armored": ["swordknight", "spearknight", "hammerknight"],
    "swordhavers": ["sword", "dagger", "swordknight", "swordcavalier"],
    "spearhavers": ["spear", "bow", "spearknight", "spearcavalier"],
    "hammerhavers": ["hammer", "gun", "hammerknight", "hammercavalier"],
    "melee": [
        "sword", "spear", "hammer",
        "swordknight", "spearknight", "hammerknight",
        "swordcavalier", "spearcavalier", "hammercavalier"
    ],
    "basic": [
        "sword", "spear", "hammer",
        "dagger", "bow"
    ],
    "advanced": [
        "sword", "spear", "hammer", "dagger", "bow",
        "sword", "spear", "hammer", "dagger", "bow",
        "swordknight", "spearknight", "hammerknight",
        "swordcavalier", "spearcavalier", "hammercavalier",
    ]
}
for (const [key, value] of Object.entries(UNIT_JOB_LISTS)) {
    unitTemplates["randoms/" + key] = {
        "randomJobKey": value.join(","),
        "templateKey": "randoms/" + key,
        "affiliation": "bad",
    }
}

unitTemplates["universal"] = {
    "affiliation": "bad",
    "templateKey": "universal",
}

import games from "@frog/source/data/games/index.js"
Object.keys(games).forEach((gameKey) => {
    const game = games[gameKey]
    Object.keys(game.player.party.units).forEach((unitKey) => {
        unitTemplates["player/" + gameKey + "/" + unitKey] = {
            "templateKey": "player/" + gameKey + "/" + unitKey,
            "key": unitKey
        }
    })
})

export default unitTemplates
